module.exports = __webpack_public_path__ + "img/3acab98.png";